import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import * as _ from 'lodash-es';

import { StateService } from '@uirouter/angular';
import { FilterService } from '../../../../services/core.filter.service';
import { UiService } from '../../../../services/core.ui.service';
import { AuditReportHelper } from './reports.audit.service.component';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { doGetPromise } from '../../../../config/core.httpclient-utils';

@Component({
    selector: 'siteAuditView',
    template: require('./reports.audit.component.html')
})
export class AdminAuditReportComponent implements OnInit {

    protected data: any = false;
    protected filters: any = null;

    protected sortFields: any = null;
    private sort: any = null;
    private paging: any = null;
    private baseFilters: any = null;

    private url = '/api/audittrail';

    constructor(
        private stateService: StateService, 
        
        private filterService:  FilterService,
        private uiService:  UiService,
        private auditReportHelper:  AuditReportHelper,
        private http: HttpClient,
        private gfTranslateService:  GfTranslateService,
    ) { }
    
    ngOnInit() {
        this.sortFields = this.auditReportHelper.getSortFields();
        this.sort = this.filterService.getSortValues();
        this.paging = this.filterService.getPagingValues();
        this.baseFilters = this.auditReportHelper.getBaseFilters();
        this.filters = this.initFilters();
        this.refreshData();
    };

    onApplyFilters = () => {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters = () => {
        this.paging.page_num = 1;
        this.filters = {
            main_fields: _.cloneDeep(this.baseFilters)
        };
        this.applyFilters();
    };

    onSort = (params: any) => {
        this.sort = {
            sort_field: _.get(params, 'key', 'id'),
            sort_dir: _.get(params, 'sortDir', 'desc')
        };
        this.applyFilters();
    };

    getDownloadUrl = (format) => {
        var fetchArgs = this.filterService.getFetchArgs({});
        fetchArgs.download = true;
        fetchArgs.format = format;
        delete fetchArgs.$inherit;  // Why is this in here?

        var queryString = _.map(
            fetchArgs,
            function (val, key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(val);
            }
        ).join('&');

        return this.url + '?' + queryString;
    };

    onPaging(params) {
        _.assignIn(this.paging, params);
        this.applyFilters();
    };

    refreshData = () => {
        this.data = false;

        var fetchArgs = this.filterService.getFetchArgs({});

        doGetPromise(this.http, this.url, fetchArgs)
        .then((response) => {
                this.data = _.get(response, 'items', []);
            },
            (response) => {
                console.log(response);
                this.data = [];
                var msg = this.gfTranslateService.translate('There was a problem loading Audit data');
                this.uiService.message.showWarning(msg, 'Data Error');
            }
        );
    };

    initFilters() {
        return {
            main_fields: this.auditReportHelper.setFiltersFromStateParams(
                _.cloneDeep(this.baseFilters)
            )
        };
    }

    applyFilters = (overrides = {}) => {
        var newParams = _.pickBy(Object.assign(
            {},
            this.sort,
            this.paging,
            this.filterService.getFilterValues(
                _.get(this.filters, 'main_fields', [])
            ),
            overrides
        ), function (value) {
            return (undefined != value && null != value && value != '');
        });

        this.stateService.go('.', newParams, { location: 'replace', inherit: false })
            .then(this.refreshData);
    }
}